import React from 'react';
import { Trans } from '@lingui/macro';

import { ButtonProps, Button } from 'components/AntD';
import { ComboBoxProps } from 'components/ComboBox';
import ComboBox from 'components/ComboBox/ComboBox';

export interface SharedSelectorProps {
  values: ComboBoxProps['selectedItems'];
  references: ComboBoxProps['availableAnswerOptions'];
  onSelectChanged: ComboBoxProps['addAnswerFunction'];
  onNextStep: ButtonProps['onClick'];
}

const SharedSelector = ({
  values,
  references,
  onSelectChanged,
  onNextStep,
}: SharedSelectorProps): JSX.Element => (
  <>
    <ComboBox
      placeholder="Search by reference name"
      availableAnswerOptions={references}
      selectedItems={values}
      addAnswerFunction={onSelectChanged}
      hasPreview={false}
      preventEnterBubble
    />
    <Button
      shape="round"
      variant="contained"
      color="primary"
      className="tw-mt-reg"
      onClick={onNextStep}
      disabled={!values?.length}
      block
    >
      <Trans>Continue</Trans>
    </Button>
  </>
);

export default SharedSelector;
